'use strict';

var RomSummaryTopOppGridService = function RomSummaryTopOppGridService() {
  var maxOpps = 10;
  function getMaxOpps() {
    return maxOpps;
  }
  function setMaxOpps(opps) {
    maxOpps = opps;
  }
  return {
    getMaxOpps: getMaxOpps,
    setMaxOpps: setMaxOpps
  };
};
module.exports = RomSummaryTopOppGridService;